import type { IChangeQuotationStatusApiPayload } from "../../models/axiosModel"

export const buildQuotationStatusChangePayload = (
    quotationId: string,
    quotationStatusId: number,
    remark?: string,
): IChangeQuotationStatusApiPayload => {
    const payload: IChangeQuotationStatusApiPayload = {
        quotation_id: quotationId,
        quotation_status_id: quotationStatusId,
    }

    if (remark !== undefined) {
        payload.remark = remark
    }

    return payload
}
